/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
*/

import type { SVGProps } from "react"

const X = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" {...props} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.79289 5.29289C6.18342 4.90237 6.81658 4.90237 7.20711 5.29289L12.5 10.5858L17.7929 5.29289C18.1834 4.90237 18.8166 4.90237 19.2071 5.29289C19.5976 5.68342 19.5976 6.31658 19.2071 6.70711L13.9142 12L19.2071 17.2929C19.5976 17.6834 19.5976 18.3166 19.2071 18.7071C18.8166 19.0976 18.1834 19.0976 17.7929 18.7071L12.5 13.4142L7.20711 18.7071C6.81658 19.0976 6.18342 19.0976 5.79289 18.7071C5.40237 18.3166 5.40237 17.6834 5.79289 17.2929L11.0858 12L5.79289 6.70711C5.40237 6.31658 5.40237 5.68342 5.79289 5.29289Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

export default X
